import { pick } from 'js/utils/ramda.util';
import { useCallback, useMemo } from 'react';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const usePagination = () => {
    const dispatch = useDynamicReducerDispatch();
    const { showCurrentRage, showPerPage, paginationOptions } = useComponentConfig();
    const { max, page, history, isLoading, totalRecords, isExportLoading }
        = useDynamicReducerSelector(pick(['max', 'page', 'history', 'isLoading', 'totalRecords', 'isExportLoading']));

    const setPage = useCallback((selectedPage) => {
        dispatch(actions.setData({ page: selectedPage }));
    }, [dispatch]);

    const setMaxPage = useCallback((selectedMaxPage) => {
        dispatch(actions.setMaxPage(selectedMaxPage));
    }, [dispatch]);

    return useMemo(() => {
        if (isLoading || isExportLoading || !history.length) {
            return null;
        }

        return {
            max,
            page,
            setPage,
            setMaxPage,
            showPerPage,
            totalRecords,
            showCurrentRage,
            paginationOptions
        };
    }, [
        max, page, setPage, isLoading, setMaxPage, showPerPage, totalRecords,
        history.length, isExportLoading, showCurrentRage, paginationOptions
    ]);
};
